module.exports = __webpack_public_path__ + "img/Zeiljachten.88e94821.svg";